import get from 'lodash/get';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { initialAuthState } from 'contexts/auth';
import { setStoredAuth } from 'api';

// A dedicated locale (rather than moment.updateLocale('en', ...)) so this
// abbreviated relative-time style only applies where it is explicitly
// requested, instead of every other fromNow()/from() call in the app.
moment.defineLocale('en-short', {
  parentLocale: 'en',
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%d sec',
    ss: '%d sec',
    m: '%d min',
    mm: '%d min',
    h: '%d hr',
    hh: '%d hr',
    d: '%d day',
    dd: '%d days',
    w: '%d wk',
    ww: '%d wks',
    M: '%d mo',
    MM: '%d mo',
    y: '%d yr',
    yy: '%d yr',
  },
});
moment.locale('en');

export const formatRelativeTimeShort = (input) => moment(input).locale('en-short').fromNow();

function showLoggedOutMessage() {
  alert('You have Been Logged Out');
}

const showLoggedOutMessageDebounced = debounce(showLoggedOutMessage, 300, {
  leading: true,
  trailing: false,
});

export const isUuid = (v) => {
  const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
  return uuidRegex.test(v);
};

// A WhatsApp message from a private chat has no group, and the parser configures
// such messages under this reserved iwatch_account_groups name.
export const DIRECT_MESSAGE_GROUP_NAME = 'Direct Messages (no group)';

export const formatGroupName = (groupName) => (groupName || '#Direct message');

export const parseJSON = (str, defaultValue) => {
  try {
    return JSON.parse(str || JSON.stringify(defaultValue));
  } catch (err) {
    return defaultValue || null;
  }
};

export const getErrorMessage = (error) => {
  const message = get(error, 'response.data.error_description')
    || get(error, 'response.data.message')
    || get(error, 'response.data.error')
    || JSON.stringify(get(error, 'response.data'))
    || get(error, 'message');
  return message;
};

export const handleErrorResponse = (err, setAuth, errMsg) => {
  if (get(err, 'response.status') === 401) {
    showLoggedOutMessageDebounced();
    setAuth({ ...initialAuthState, required: true });
    setStoredAuth(initialAuthState);
  } else {
    alert(errMsg || getErrorMessage(err));
  }
};
